import { useFormContext } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import type { CreateSurveyFormValues } from '../../types/survey.types';
import { NumberField } from './primitives/NumberField';

interface QuestionMaxCharsFieldProps {
  questionIndex: number;
}

export function QuestionMaxCharsField({ questionIndex }: QuestionMaxCharsFieldProps) {
  const { control } = useFormContext<CreateSurveyFormValues>();

  return (
    <FormField
      control={control}
      name={`questions.${questionIndex}.maxChars`}
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel>Max characters</FormLabel>
          <FormControl>
            <NumberField
              value={field.value}
              onChange={field.onChange}
              min={1}
              step={1}
              className="sm:w-48"
              aria-invalid={fieldState.invalid || undefined}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
